export default {"src":"/_next/static/media/hot-news-fire.27fefce9.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};